import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { DeletePhysicalSocket } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-hub-service/src/core/charge-points/filters/delete-physical-socket.interface';
import { SubmitErrorHandler } from 'react-hook-form';

import { useDeleteChargePointChannelPhysicalSocketContext } from '../../charge-point.context';
import { ChargePointChannelPhysicalSocketDeleteFormStep1Controller } from '../charge-point-channel-physical-socket-delete-form-step-1/charge-point-channel-physical-socket-delete-form-step-1.controller';

export interface ChargePointChannelPhysicalSocketDeleteFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<
      DeletePhysicalSocket,
      'chargePointId' | 'channelId' | 'physicalSocketId'
    >
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<
      DeletePhysicalSocket,
      'chargePointId' | 'channelId' | 'physicalSocketId'
    >
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointChannelPhysicalSocketDeleteFormController = (
  props: ChargePointChannelPhysicalSocketDeleteFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useDeleteChargePointChannelPhysicalSocketContext();

  return (
    <MultiStepFormProvider<
      Pick<
        DeletePhysicalSocket,
        'chargePointId' | 'channelId' | 'physicalSocketId'
      >
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['chargePointId', 'channelId', 'physicalSocketId'],
          component: (
            <ChargePointChannelPhysicalSocketDeleteFormStep1Controller />
          ),
        },
      ]}
    />
  );
};
